import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { LoaderService } from '@app/services/loader.service';
import { Observable } from 'rxjs';
import { APP_CONFIG, AppConfiguration } from '@app/infrastructure/auth/app-configuration';

@Component({
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
	public readonly isLoading$: Observable<boolean> = this.loaderService.isLoading$;

	constructor(
		@Inject(APP_CONFIG)
		private appConfig: AppConfiguration,
		private loaderService: LoaderService,
	) {}

	public get loaderClass(): string {
		return this.appConfig.partner.prefix !== 'cloudvisor' ? 'partner-loader-logo' : 'cv-loader-logo';
	}
}
